// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  font-family: var(--ion-font-family);
}

.fieldset {
  border: 1px solid var(--ion-lighter-primary);
  font-size: 12px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5vh;
  padding: 0vh 1.5vh 0.35vh;
  width: 100%;
  max-height: 5vh;
  min-height: 5vh;
  font-weight: 400;
  pointer-events: all;
  text-transform: capitalize;
  letter-spacing: 1px;
  color: var(--ion-darker-primary);
  margin: 1vw 0 0 0vh;
  transition: all 0.3s ease-in-out;
}
.fieldset.is-focused {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 5px rgba(var(--ion-color-primary-rgb), 0.3);
}
.fieldset .legend {
  color: var(--ion-color-primary);
  text-transform: capitalize;
  font-weight: 500;
  font-size: 10px;
  padding: 0vh 1vh;
  letter-spacing: 1px;
}
.fieldset .bioicon {
  color: var(--ion-color-primary);
  fill: none;
  stroke: var(--ion-color-primary);
  padding: 0;
  height: 2.5vh;
  width: 2.5vh;
  transition: all 0.5s ease-in-out;
  cursor: pointer;
  margin-right: 0.5vh;
}
.fieldset .eye-pwd {
  color: var(--ion-color-danger);
  fill: none;
  stroke: var(--ion-color-danger);
  padding: 0;
  height: 2.5vh;
  width: 2.5vh;
  transition: all 0.5s ease-in-out;
  cursor: pointer;
  margin-right: 0.5vh;
}
.fieldset .inner-input {
  flex-grow: 1;
  outline: none;
  border: none;
  background: transparent;
  padding: 0 0.5vh;
  font-size: 12px;
  border-radius: 0px;
  box-shadow: none;
  margin: 0;
  height: calc(5vh - 3vw);
  color: var(--ion-darker-primary);
  width: 100%;
}
.fieldset .inner-input::placeholder {
  color: var(--ion-dark-primary);
}
.fieldset.disabled-input .inner-input {
  background-color: var(--ion-color-step-100, #f8f8f8);
  cursor: not-allowed;
}

.withoutM {
  margin: 0;
}

.is-name-selected {
  width: 100%;
}

.is-name-small {
  width: 75%;
}

.passForget {
  color: var(--ion-color-danger);
  padding: 0;
  margin: 1vh;
  height: 3vh;
  width: 3vh;
  border-radius: 8px;
  transition: all 0.5s ease-in-out;
  border: 1.5px dashed var(--ion-color-danger);
  box-sizing: content-box;
  cursor: pointer;
}

.hidden-input {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-input/app-input.component.scss"],"names":[],"mappings":"AAGA;EACE,mCAAA;AAFF;;AAIA;EACE,4CAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gCAAA;AADF;AAIE;EACE,sCAAA;EACA,2DAAA;AAFJ;AAKE;EACE,+BAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;AAME;EAEF,+BAAA;EACI,UAAA;EACA,gCAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;AALJ;AAQE;EACF,8BAAA;EACI,UAAA;EACA,+BAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;AANJ;AASE;EAEE,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;EACA,WAAA;AARJ;AAYE;EACE,8BAAA;AAVJ;AAcE;EACE,oDAAA;EACA,mBAAA;AAZJ;;AAkBA;EACE,SAAA;AAfF;;AAsCA;EACE,WAAA;AAnCF;;AAqCA;EACE,UAAA;AAlCF;;AA+CA;EACE,8BAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;EACA,4CAAA;EACA,uBAAA;EACA,eAAA;AA5CF;;AAgDA;EACE,aAAA;AA7CF","sourcesContent":["// src/app/components/generic-input/generic-input.component.scss\n\n\n:host{\n  font-family: var(--ion-font-family);\n}\n.fieldset {\n  border: 1px solid var(--ion-lighter-primary);\n  font-size: 12px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5vh; // Adjusted gap for internal elements\n  padding: 0vh 1.5vh 0.35vh;\n  width: 100%;\n  max-height: 5vh;\n  min-height: 5vh;\n  font-weight: 400;\n  pointer-events: all; // Allow clicks\n  text-transform: capitalize;\n  letter-spacing: 1px; // Adjusted for better readability\n  color: var(--ion-darker-primary); // Adjusted for better Ionic color variable usage (black-secondary might not exist)\n  margin: 1vw 0 0 0vh; // This margin is specific to the parent's layout.\n  transition: all 0.3s ease-in-out; // Consistent transition for fieldsets\n\n  // Focused state for the fieldset itself (applied via parent component)\n  &.is-focused {\n    border-color: var(--ion-color-primary); // Use primary color for focused border\n    box-shadow: 0 0 5px rgba(var(--ion-color-primary-rgb), 0.3); // Soft glow\n  }\n\n  .legend {\n    color: var(--ion-color-primary); // Legend text color\n    text-transform: capitalize;\n    font-weight: 500;\n    font-size: 10px;\n    padding: 0vh 1vh;\n    letter-spacing: 1px;\n  }\n\n  .bioicon {\n    // Styles for leading icons (e.g., user, device, email)\ncolor: var(--ion-color-primary);\n    fill: none;\n    stroke: var(--ion-color-primary);\n    padding: 0;\n    height: 2.5vh;\n    width: 2.5vh;\n    transition: all 0.5s ease-in-out;\n    cursor: pointer;\n    margin-right: 0.5vh;// Small space after icon, before input if needed\n  }\n\n  .eye-pwd {\ncolor: var(--ion-color-danger);\n    fill: none;\n    stroke: var(--ion-color-danger);\n    padding: 0;\n    height: 2.5vh;\n    width: 2.5vh;\n    transition: all 0.5s ease-in-out;\n    cursor: pointer;\n    margin-right: 0.5vh;// Small space before icon, after input if needed\n  }\n\n  .inner-input {\n    // Styles for the native <input> element\n    flex-grow: 1; // Allows input to take remaining space in flex container\n    outline: none;\n    border: none;\n    background: transparent;\n    padding: 0 0.5vh; // Adjusted padding to fit within fieldset\n    font-size: 12px;\n    border-radius: 0px;\n    box-shadow: none;\n    margin: 0;\n    height: calc(5vh - 3vw); // Adjusted height\n    color: var(--ion-darker-primary); // Text color for input\n    width: 100%; // Fill available width, works with flex-grow\n  }\n\n  // Placeholder styling for native input\n  .inner-input::placeholder {\n    color: var(--ion-dark-primary);\n  }\n\n  // Readonly/Disabled input styling\n  &.disabled-input .inner-input {\n    background-color: var(--ion-color-step-100, #f8f8f8); // Lighter background for disabled\n    cursor: not-allowed;\n  }\n}\n\n// Specific fieldset classes (passed via additionalClasses input)\n// These would add to the base .fieldset class\n.withoutM {\n  margin: 0; // Example: if it means no margin\n}\n\n.fname,\n.lname {\n  // These will be used by the parent to control width dynamically\n  // The 'is-focused' class should apply to the *fieldset* not individual input\n}\n\n// These classes will be applied by the parent component to the specific instances of app-generic-input\n// Example: <app-generic-input [additionalClasses]=\"['phonenumberBox']\">\n.phonenumberBox {\n  // Specific styling for phone number box if needed\n}\n.emailBox {\n  // Specific styling for email box if needed\n}\n.areaBox {\n  // Specific styling for area box if needed\n}\n\n// Classes for width changes managed by parent (e.g., for first/last name fields)\n// These should be applied to the <app-generic-input> itself in the parent HTML\n.is-name-selected {\n  width: 100%; // When this name field is selected\n}\n.is-name-small {\n  width: 75%; // When the other name field is selected\n}\n\n// // Other general classes that might be applied by the parent\n// .stagBar {\n//   display: flex;\n//   flex-direction: row;\n//   align-items: flex-end;\n//   justify-content: flex-start;\n//   width: 100%;\n//   gap: 3vw; // Gap between multiple fieldsets\n// }\n\n.passForget {\n  color: var(--ion-color-danger); // Icon color\n  padding: 0;\n  margin: 1vh;\n  height: 3vh;\n  width: 3vh;\n  border-radius: 8px;\n  transition: all 0.5s ease-in-out;\n  border: 1.5px dashed var(--ion-color-danger);\n  box-sizing: content-box;\n  cursor: pointer;\n  // This likely applies to an ion-icon OUTSIDE of the GenericInputComponent\n}\n\n.hidden-input {\n  display: none; // For hidden inputs (like areasOrRegionId)\n}\n\n// .termsBox {\n//   margin: 1vh 0;\n//   display: flex;\n//   align-items: center;\n//   gap: 1vh;\n//   font-size: 12px;\n// }\n\n// .termsLink {\n//   color: var(--ion-darker-info); // Assuming this variable exists\n//   text-decoration: underline 1px solid var(--ion-darker-info);\n//   cursor: pointer;\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
